import React, { useEffect, useState } from "react";
import InstallationCompletedView from "./InstallationCompletedView";
import crmservices from '../../wsclient';
import { httpBackOfficeUtil } from "../../wsclient/crmservices/httpBackOfficeUtil";
import { useTranslation } from "react-i18next";
import InstallationDetailView from "./InstallationDetailView";
import InstallationUpdateActivityView from "./InstallationUpdateActivityView";
import { getCustomFieldByKey } from "../../utils/util";
import InstallationAddDeviceController from "./InstallationAddDeviceController";
import ConfirmComponent from "../../components/Confirm";

export default function InstallationCompletedController(props) {
	const { t } = useTranslation();
	const [installations, setInstallations] = useState([]);
	const [showLoadingInstallation, setShowLoadingInstallation] = useState(true);
	const [orderDetail, setOrderDetail] = useState(null);
	const [activities, setActivities] = useState([]);
	const [showAddDevice, setShowAddDevice] = useState(false);
	const [activeStepAddDevice, setActiveStepAddDevice] = useState(false);
	const [quantityPG, setQuantityPG] = useState(0);

	const [paging, setPaging] = useState({
		page: 1,
		size: 10,
		total: 0,
		has_more: false
	});

	const setShowProcessing = props.setShowProcessing;
	const showMessage = props.showMessage;

	useEffect(() => {
		if (props.stageId) {
			onLoadListInstallation();
		}
	}, [props.stageId]);

	useEffect(() => {
		if (props.isReloadList) {
			onLoadListInstallation();
		}
	}, [props.isReloadList]);

	const onLoadListInstallation = async (page, size) => {
		console.log("AAAAAAAAAAAAA onLoadListInstallation");
		console.log("AAAAAAAAAAAAA onLoadListInstallation");
		console.log("AAAAAAAAAAAAA onLoadListInstallation");
		console.log("AAAAAAAAAAAAA onLoadListInstallation");
		console.log("AAAAAAAAAAAAA onLoadListInstallation");
		console.log("AAAAAAAAAAAAA onLoadListInstallation");
		let data = [];
		let _paging = {
			page: 1,
			size: 10,
			total: 0
		}
		try {
			let myUserId = httpBackOfficeUtil.getSession().sub;
			var result = await crmservices.orders.getListInstallation({
				page: page ? page : 1,
				size: size ? size : 10,
				stage_id: props.stageId,
				custom_fields: `assigned_to;${myUserId};enable_devices;0`,
				include_total: true,
			});
			console.log("AAAAAAAAAAAAA onLoadListInstallation:",result);
			if (result.code === 'OK') {
				data = result.data.content ? result.data.content : [];
				_paging = result.data.paging;
				if (_paging.size < paging.size) {
					_paging.size = paging.size
				}
			}
			setInstallations(data);
			setPaging(_paging)
		} catch (error) {
			console.log("load installations error:", error);
		}
		setShowLoadingInstallation(false);
	}

	const handleChangePage = async (page) => {
		console.log("AAA page:", page);
		await onLoadListInstallation(page);
	}

	const handleChangeRowsPerPage = async (size) => {
		console.log("AAA size:", size);
		await onLoadListInstallation(1, size);
	}

	const onShowDetail = async (installation) => {
		if (orderDetail && orderDetail.id == installation) {
			setOrderDetail(installation);
			setShowAddDevice(true);
			checkActiveTab(orderDetail);
		} else {
			setShowProcessing(true);
			try {
				const result = await crmservices.orders.getOrderDetail(installation.id);
				if (result.code == 'OK') {
					installation = { ...installation, ...result.data };
					setOrderDetail(installation);
					setShowAddDevice(true);
					checkActiveTab(installation);
				}else{
					showMessage({
						status: true,
						message: t('EXCEPTION_PROCESS'),
						title: t('ERROR'),
					});
				}
			} catch (ex) {
				console.log("onShowDetail ex:", ex);
				showMessage({
					status: true,
					message: t('EXCEPTION_PROCESS'),
					title: t('ERROR'),
				});
			}
			setShowProcessing(false);
		}
	}

	const checkActiveTab = (orderDetail) => {
		let _active = 0;
		let addingDevice = getCustomFieldByKey(orderDetail.custom_fields, "adding_device");
		let enable_device = getCustomFieldByKey(orderDetail.custom_fields, "enable_device");
		if(!addingDevice || addingDevice == "0"){
			_active = 0;
		}else{
			if(!enable_device || enable_device == "0"){
				_active = 1;
			}else{
				_active = 2;
			}
		}
		setActiveStepAddDevice(_active)
	}

	const onCloseAddDevice = (triggerReload) => {
		setShowAddDevice(false);
		if(triggerReload){
			onLoadListInstallation();
		}
	}
	console.log("AAA orderDetail:",orderDetail);
	return (
		<>
			<InstallationCompletedView
				installations={installations}
				showLoadingInstallation={showLoadingInstallation}
				paging={paging}
				handleChangePage={handleChangePage}
				handleChangeRowsPerPage={handleChangeRowsPerPage}
				onShowDetail={onShowDetail}
			/>

			{showAddDevice && <InstallationAddDeviceController
				isOpen={showAddDevice}
				activities={activities}
				orderDetail={orderDetail}
				activeStepAddDevice={activeStepAddDevice}
				onClose={onCloseAddDevice}
			/>}
		</>
	)
}